export default [
  //生产管理
  {
    path: '/order_examine',
    name: 'order_examine',
    component: () => import('@/components/productionManagement/order_examine'),
    redirect: '/order_examine/order_review',
    children: [{
        path: '/order_examine/order_review',
        name: 'order_review',
        component: () => import('@/components/productionManagement/order_review')
      },

      {
        path: '/order_examine/order_review2',
        name: 'order_review2',
        component: () => import('@/components/productionManagement/order_review2')
      },
      {
        path: '/order_examine/order_areas',
        name: 'order_areas',
        component: () => import('@/components/productionManagement/order_areas')
      }
    ]
  },




  {
    path: '/order_production/productDetail',
    name: 'productDetail',
    component: () => import('@/components/productionManagement/productDetail')
  },
  {
    path: '/order_productionlist',
    name: 'order_productionlist',
    component: () => import('@/components/productionManagement/order_productionlist')
  },
  {
    path: '/order_production',
    name: 'order_production',
    component: () => import('@/components/productionManagement/order_production')
  },
  {
    path: '/order_productionzdsc',
    name: 'order_productionzdsc',
    component: () => import('@/components/productionManagement/order_productionzdsc')
  },
  {
    path: '/order_productionzdsc/tidanbaobiao',
    name: 'tidanbaobiao',
    component: () => import('@/components/productionManagement/tidanbaobiao')
  },
  {
    path: '/order_productionzdsc/yc_productionzdsc',
    name: 'yc_productionzdsc',
    component: () => import('@/components/productionManagement/yichangdingdan')
  },
  {
    path: '/order_productionzdsc/dizhiku',
    name: 'dizhiku',
    component: () => import('@/components/setup/guize/dizhiku'),
  },
  // {
  // 	path: '/yichangdingdan',
  // 	name: 'yichangdingdan',
  // 	component: () => import('@/components/productionManagement/yichangdingdan')
  // },

  {
    path: '/productionBasismanagAdd',
    name: 'productionBasismanagAdd',
    component: () => import('@/components/productionDelivery/productionBasismanagAdd')
  },
  {
    path: '/productionBasismanag/zidongshengchanguanli',
    name: 'zidongshengchanguanli',
    component: () => import('@/components/productionDelivery/zidongshengchanguanli')
  },

  {
    path: '/orderUpload',
    name: 'orderUpload',
    component: () => import('@/components/productionManagement/orderUpload')
  },

  {
    path: '/order_production/order_export',
    name: 'order_export',
    component: () => import('@/components/productionManagement/order_export')
  },



  //到这为止

  {
    path: '/productionBasismanag',
    name: 'productionBasismanag',
    component: () => import('@/components/productionDelivery/productionBasismanag')
  },
  {
    path: '/productionBasismanag/productionBasismanagSoldout',
    name: 'productionBasismanagSoldout',
    component: () => import('@/components/productionDelivery/productionBasismanagSoldout')
  },
  {
    path: '/productionBasismanag/productionBasismanagDj',
    name: 'productionBasismanagDj',
    component: () => import('@/components/productionDelivery/productionBasismanagDj')
  },
  {
    path: '/productionBasismanag/productionBasismanagAI',
    name: 'productionBasismanagAI',
    component: () => import('@/components/productionDelivery/productionBasismanagAI')
  },
  {
    path: '/productionBasismanag/productionBasismanagAItidan',
    name: 'productionBasismanagAItidan',
    component: () => import('@/components/productionDelivery/productionBasismanagAItidan')
  },
  {
    path: '/productionBasismanag/productionBasismanagCheck',
    name: 'productionBasismanagCheck',
    component: () => import('@/components/productionDelivery/productionBasismanagCheck')
  },
  {
    path: '/productionBasismanag/apicheckorder',
    name: 'apicheckorder',
    component: () => import('@/components/productionDelivery/apicheckorder')
  },
  {
    path: '/productionBasismanag/qudaodingdan',
    name: 'qudaodingdan',
    component: () => import('@/components/productionDelivery/qudaodingdan')
  },
  {
    path: '/productionBasismanag/qudaodingdanduilie',
    name: 'qudaodingdanduilie',
    component: () => import('@/components/productionDelivery/qudaodingdanduilie')
  },


  {
    path: '/order_catch',
    name: 'order_catch',
    component: () => import('@/components/productionManagement/order_catch'),
    redirect: '/order_catch/order_catchjd',
    mate: ['京东抓单', '拼多多抓单'],
    children: [{
        path: '/order_catch/order_catchjd',
        component: () => import('@/components/productionManagement/order_catchjd')
      },
      {
        path: '/order_catch/order_catchpdd',
        component: () => import('@/components/productionManagement/order_catchpdd')
      },
      {
        path: '/order_catch/order_catchpdd2',
        name: 'order_catchpdd2',
        component: () => import('@/components/productionManagement/order_catchpdd2')
      },
      {
        path: '/order_catch/order_kuaishou',
        name: 'order_kuaishou',
        component: () => import('@/components/productionManagement/order_kuaishou')
      },
      {
        path: '/order_catch/order_douyin',
        name: 'order_douyin',
        component: () => import('@/components/productionManagement/order_douyin')
      },

      {
        path: '/order_catch/order_catchpddcook',
        component: () => import('@/components/productionManagement/order_catchpddcook')
      },

      {
        path: '/order_catch/order_catchyz',
        component: () => import('@/components/productionManagement/order_catchyz')
      },
      {
        path: '/order_catch/order_catchxhs',
        component: () => import('@/components/productionManagement/order_catchxhs')
      },
      {
        path: '/order_catch/order_zhibo',
        component: () => import('@/components/productionManagement/order_zhibo')
      },
      {
        path: '/order_catch/shopquanzhibojianpeizhi',
        component: () => import('@/components/productionManagement/shopquanzhibojianpeizhi')
      },

      {
        path: '/order_catch/order_catchtm',
        component: () => import('@/components/productionManagement/order_catchtm')
      },
      {
        path: '/order_catch/order_catchtm2',
        component: () => import('@/components/productionManagement/order_catchtm2')
      },
      {
        path: '/order_catch/order_catchtmcook',
        component: () => import('@/components/productionManagement/order_catchtmcook')
      },
      {
        path: '/order_catch/order_catchtmsq',
        component: () => import('@/components/productionManagement/order_catchtmsq')
      },
      {
        path: '/order_catch/order_catchpddsq',
        component: () => import('@/components/productionManagement/order_catchpddsq')
      },
      {
        path: '/order_catch/order_catchjdlogs',
        component: () => import('@/components/productionManagement/order_catchjdlogs')
      },
      {
        path: '/order_catch/order_catchpddlogs',
        component: () => import('@/components/productionManagement/order_catchpddlogs')
      },
      {
        path: '/order_catch/order_catchtmlogs',
        component: () => import('@/components/productionManagement/order_catchtmlogs')
      },
    ]
  },

  //新增刷单拦截
  {
    path: '/order_question/shuadanadd',
    name: 'shuadanadd',
    component: () => import('@/components/orderManagement/shuadanadd')
  },
  {
    path: '/order_catchpdd2d',
    name: 'order_catchpdd2d',
    component: () => import('@/components/productionManagement/order_catchpdd2d')
  },


  {
    path: '/order_export2',
    name: 'order_export2',
    component: () => import('@/components/productionManagement/order_export2')
  },
  {
    path: '/order_exporttouliu',
    name: 'order_exporttouliu',
    component: () => import('@/components/productionManagement/order_exporttouliu')
  },
  {
    path: '/order_export3',
    name: 'order_export3',
    component: () => import('@/components/productionManagement/order_export3')
  },
  {
    path: '/order_export4',
    name: 'order_export4',
    component: () => import('@/components/productionManagement/order_export4')
  },
  {
    path: '/order_export_yunying',
    name: 'order_export_yunying',
    component: () => import('@/components/productionManagement/order_export_yunying')
  },
  {
    path: '/order_export_yunying2',
    name: 'order_export_yunying2',
    component: () => import('@/components/productionManagement/order_export_yunying2')
  },
  {
    path: '/order_export_waihuyeji',
    name: 'order_export_waihuyeji',
    component: () => import('@/components/productionManagement/order_export_waihuyeji')
  },
  {
      path: '/order_export_waihuyeji2',
      name: 'order_export_waihuyeji2',
      component: () => import('@/components/productionManagement/order_export_waihuyeji2')
    },
  {
    path: '/order_export_waihurenwu',
    name: 'order_export_waihurenwu',
    component: () => import('@/components/productionManagement/order_export_waihurenwu')
  },
  {
    path: '/order_export5',
    name: 'order_export5',
    component: () => import('@/components/productionManagement/order_export5')
  },
  {
    path: '/order_export6',
    name: 'order_export6',
    component: () => import('@/components/productionManagement/order_export6')
  },
  {
    path: '/order_export7',
    name: 'order_export7',
    component: () => import('@/components/productionManagement/order_export7')
  },
  {
    path: '/order_production/shengchanfahuodaoru',
    name: 'shengchanfahuodaoru',
    component: () => import('@/components/productionManagement/shengchanfahuodaoru')
  },
  {
    path: '/order_question/shuadanqingli',
    name: 'shuadanqingli',
    component: () => import('@/components/productionManagement/shuadanqingli')
  },
]



// WEBPACK FOOTER //
// ./src/router/shengchan.js